import React, { useState, useEffect, useRef } from "react";

const BotonFlotanteLector = () => {
  const [seleccion, setSeleccion] = useState("");
  const [leyendo, setLeyendo] = useState(false);
  const [posicion, setPosicion] = useState({
    x: window.innerWidth - 80,
    y: window.innerHeight - 80,
  });

  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });
  const utteranceRef = useRef(null);

  useEffect(() => {
    const manejarSeleccion = () => {
      const texto = window.getSelection().toString();
      setSeleccion(texto);
    };

    document.addEventListener("mouseup", manejarSeleccion);
    document.addEventListener("keyup", manejarSeleccion);

    return () => {
      document.removeEventListener("mouseup", manejarSeleccion);
      document.removeEventListener("keyup", manejarSeleccion);
    };
  }, []);

  // 🔥 iniciar drag
  const handleMouseDown = (e) => {
    dragging.current = true;
    offset.current = {
      x: e.clientX - posicion.x,
      y: e.clientY - posicion.y,
    };
  };

  // 🔥 mover
  const handleMouseMove = (e) => {
    if (!dragging.current) return;

    setPosicion({
      x: e.clientX - offset.current.x,
      y: e.clientY - offset.current.y,
    });
  };

  // 🔥 soltar
  const handleMouseUp = () => {
    dragging.current = false;
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const leerTextoSeleccionado = () => {
    if (seleccion.trim() !== "") {
      if (speechSynthesis.speaking) {
        speechSynthesis.cancel();
      }
      const utterance = new SpeechSynthesisUtterance(seleccion);
      utterance.lang = "es-ES";
      utterance.onend = () => setLeyendo(false);
      utterance.onerror = () => setLeyendo(false);
      utteranceRef.current = utterance;
      setLeyendo(true);
      window.speechSynthesis.speak(utterance);
    } else {
      alert("No hay texto seleccionado");
    }
  };

  const detenerLectura = () => {
    window.speechSynthesis.cancel();
    setLeyendo(false);
  };

  return (
    <button
      onMouseDown={handleMouseDown}
      onClick={leyendo ? detenerLectura : leerTextoSeleccionado}
      style={{
        position: "fixed",
        left: `${posicion.x}px`,
        top: `${posicion.y}px`,
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        backgroundColor: leyendo ? "#d32f2f" : "#1976d2",
        color: "white",
        fontSize: "24px",
        border: "none",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
        cursor: "grab",
        zIndex: 1000,
      }}
      title={leyendo ? "Detener lectura" : "Leer selección"}
    >
      {leyendo ? "⏹" : "🔊"}
    </button>
  );
};

export default BotonFlotanteLector;
